import {
  TaskLabel,
  WebSocketAction,
  WebSocketEntityType,
} from '@this+that/models';
import log from 'loglevel';

import type { IEventEmitter } from '../EventEmitter';
import { WebSocketEventType } from '../WebSocketContext';

export function createTaskLabelMessageHandler(eventEmitter: IEventEmitter) {
  return (action: WebSocketAction, item: TaskLabel) => {
    try {
      switch (action) {
        case WebSocketAction.INSERT:
          log.debug(`[TaskLabelHandler] INSERT TaskLabel ${item.id}`);
          eventEmitter.emit(
            WebSocketEntityType.TaskLabel,
            WebSocketEventType.INSERT,
            item,
          );
          break;
        case WebSocketAction.MODIFY:
          log.debug(`[TaskLabelHandler] MODIFY TaskLabel ${item.id}`);
          eventEmitter.emit(
            WebSocketEntityType.TaskLabel,
            WebSocketEventType.MODIFY,
            item,
          );
          break;
        case WebSocketAction.REMOVE:
          log.debug(`[TaskLabelHandler] REMOVE TaskLabel ${item.id}`);
          eventEmitter.emit(
            WebSocketEntityType.TaskLabel,
            WebSocketEventType.REMOVE,
            item,
          );
          break;
        default:
          log.warn('[TaskLabelHandler] Unknown action for TaskLabel:', action);
      }
    } catch (error) {
      log.error('[TaskLabelHandler] Handler failed:', error);
    }
  };
}
